// extracted by mini-css-extract-plugin
module.exports = {"form":"NewNoteForm_form__3IOhJ","control":"NewNoteForm_control__3Vqc5","actions":"NewNoteForm_actions__21cbh"};